import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const IdentityVerification: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path d="M2.75 0A2.75 2.75 0 0 0 0 2.75v2.5a.75.75 0 0 0 1.5 0v-2.5c0-.69.56-1.25 1.25-1.25h2.5a.75.75 0 0 0 0-1.5h-2.5Zm8 0a.75.75 0 0 0 0 1.5h2.5c.69 0 1.25.56 1.25 1.25v2.5a.75.75 0 0 0 1.5 0v-2.5A2.75 2.75 0 0 0 13.25 0h-2.5Zm-10 10a.75.75 0 0 1 .75.75v2.5a1.25 1.25 0 0 0 1.033 1.231A4 4 0 0 1 6.5 11h3a4 4 0 0 1 3.967 3.481A1.25 1.25 0 0 0 14.5 13.25v-2.5a.75.75 0 0 1 1.5 0v2.5A2.75 2.75 0 0 1 13.25 16h-2.5a.75.75 0 0 1 0-1.5h1.2a2.5 2.5 0 0 0-2.45-2h-3a2.5 2.5 0 0 0-2.45 2h1.2a.75.75 0 0 1 0 1.5h-2.5A2.75 2.75 0 0 1 0 13.25v-2.5A.75.75 0 0 1 .75 10Z"></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.194 3.798a3.25 3.25 0 1 1 3.612 5.404 3.25 3.25 0 0 1-3.612-5.404ZM8 4.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
            ></path>
        </Icon>
    );
};
